export default [
    { label: "ИП", value: "ip" },
    { label: "ООО", value: "jp" },
]
